import { render, staticRenderFns } from "./BitburstUserDetails.vue?vue&type=template&id=563e43fb&scoped=true"
import script from "./BitburstUserDetails.vue?vue&type=script&lang=js"
export * from "./BitburstUserDetails.vue?vue&type=script&lang=js"
import style0 from "./BitburstUserDetails.vue?vue&type=style&index=0&id=563e43fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563e43fb",
  null
  
)

export default component.exports